module.exports = __webpack_public_path__ + "img/records-submitted-en.5e6f8ea4.png";